module.exports = __webpack_public_path__ + "static/testimonial-1-ba231cd9151db807052987f5c9af78e7.png";